import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { getCurrentUser, hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';
import { ActivatedRoute } from '@angular/router';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { CargueV, CargueService } from '../services/cargue-cuentasBloqueadas.service';

@Component({
    selector: 'cargue-cuentasBloqueadas',
    templateUrl: './cargue-cuentasBloqueadas.component.html',
    styleUrls: ['./cargue-cuentasBloqueadas.component.scss'],
    styles: [
    `
    @media only screen and (max-width: 500px) {
        .card-body {
            flex-wrap: wrap
        }
        }
        `
    ]
})
export class CargueBloqueadasComponent implements OnInit {
    file: File;
    recordsToSend: number = 1000; //--> No de registros que se enviarán en cada request
    reader = new FileReader();
    isFileLoaded: boolean = false
    textFileLoaded: String
    lastTextFileLoaded: String
    csvMatriz: string[] = [];
    csvHeader: string[] = [];
    parsedInfo: any[] = []
    incorrectInfo: any[] = []
    inputFile: HTMLInputElement
    cuentasBloqueadas: any[] = [];
    filteredCuentas: any[] = [];
    searchTerm: string = '';

    // Paginación
    pageSize: number = 20; // Puedes ajustar el tamaño de página aquí
    currentPage: number = 1;
    totalPages: number = 1;
    pagesArray: number[] = [];

    cargueForm: FormGroup = new FormGroup({
        periodo: new FormControl('', [Validators.required, Validators.pattern(/^.{4,6}$/)]
        ),
    })
    constructor(private notificationService: NotificationHelper,
        private activatedRoute: ActivatedRoute,
        private helpers: HelpersService,
        private cargueService: CargueService,

    ) {
        this.reader.addEventListener('load', (event) => {
            showSpinner()
            this.textFileLoaded = this.reader.result ? this.reader.result as string : "";
            this.csvMatriz = this.textFileLoaded.split(/\r\n|\n/)
            try {
            this.onLoadFile()
            } catch (error: any) {
            this.notificationService.errorMessage(error.message)
            }
            hideSpinner()
        });
        const data = this.activatedRoute.snapshot.data
        if (data.title) {
            this.helpers.setTitle(data.title);
        }
    } 
    onSelectFile(e: HTMLInputElement) {
    
        this.parsedInfo = []
        this.incorrectInfo = []
    
        showSpinner()
        this.inputFile = e
        const files = this.inputFile.files;
        if (files && files.length) {
        this.reader.readAsText(files[0]);
        } else {
        this.notificationService.errorMessage("No se seleccionó ningún archivo.");
        }
        hideSpinner();
    }
    onLoadFile() {
        showSpinner();
        if (this.csvMatriz == undefined || this.csvMatriz.length <= 0) {
            throw new Error("Este archivo no contiene datos.");
        }
        const shift = this.csvMatriz[0];
        if (!shift) {
            throw new Error("Error leyendo encabezados")
        }
        // Obtenemos el header
        this.csvHeader = shift.replace(/"/g, '').split(/[,;]/);
        // Validamos el header
        if (this.csvMatriz.length <= 0) {
            throw new Error("El archivo tiene el formato, pero no tiene registros.");
        }

        this.csvMatriz.forEach((value, index) => {
            const split = value.replace(/"/g, '').split(/[,;]/);
            // Validamos que el registro tenga la cantidad de columnas esperadas
            if (split.length === 13) {
                const item: CargueV = {
                    clave: split[0]?.trim() || "",
                    c_agr: split[1]?.trim() || "",
                    t_cre: split[2]?.trim() || "",
                    cue: split[3]?.trim() || "",
                    n_ori: split[4]?.trim() || "",
                    fue: split[5]?.trim() || "",
                    n_fue: split[6]?.trim() || "",
                    ven: split[7]?.trim() || "",
                    valor: split[8]?.trim() || "",
                    capital: split[9]?.trim() || "",
                    interes: split[10]?.trim() || "",
                    val_seguro: split[11]?.trim() || "",
                    interes_mgracias: split[12]?.trim() || "",
                };
                if (
                    item.clave
                ) {
                    this.parsedInfo.push(item);
                } else {
                    this.incorrectInfo.push(item);
                }
            } else {
                console.warn(`Registro en la línea ${index + 1} no tiene el formato esperado.`);
            }
        });

        if (this.incorrectInfo.length > 0) {
            this.notificationService.warningMessage(`Se encontraron ${this.incorrectInfo.length} registros no válidos.`)
        } else if(this.parsedInfo.length > 0) {
            this.notificationService.infoMessage(`Se encontraron ${this.parsedInfo.length} registros válidos.`)
            this.enableSendButton()
        }
        hideSpinner()
    }
    
    disableButtonAndDeleteLoadedInfo() {
        this.parsedInfo = [];
        this.csvMatriz = [];
        this.csvHeader = [];
        this.isFileLoaded = false;
        this.incorrectInfo = []
    }
    
    enableSendButton() {
        this.isFileLoaded = true;
    }
    onResetForm() {
    this.cargueForm.reset();
    }

    ConvertToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = '';
    for (let index in headerList) {
    row += headerList[index] + ';';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (let i = 0; i < array.length; i++) {
        let line = '';

    for (let index in headerList) {
        let head = headerList[index];
        line +=  array[i][head]+';';
    }

    str += line + '\r\n';
    }
    return str;
    }

    doFile(data, filename='data') {
    let csvData = this.ConvertToCSV(data, Object.keys(data[0]));
    let dataFile = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    return dataFile
    }

    async onSubmit(): Promise<void> {
        if (this.parsedInfo.length > 0) {
        const divisor = this.parsedInfo.length / this.recordsToSend;
        let dividedData: any[] = [];
    
        for (let i = 0; i < divisor; i++) {
            const element = this.parsedInfo.slice(i * this.recordsToSend, (i + 1) * this.recordsToSend);
            dividedData.push(element)
        }
        let contador= 1;
        for(let element of   dividedData){
            let porcentaje = Math.round((contador / dividedData.length) * 100);
            showSpinner(`Cargando Registros  ${porcentaje} %...`);
            try {
            const usuario = getCurrentUser();
            const empresa = usuario ? usuario.c_emp : 'JA';
            const usuarioId = usuario ? usuario.usuario_aplicativo : 'SADMIN';
            const res = await this.cargueService.cargue(empresa || 'JA', element,usuarioId);
            
            if(!res.success) {
                this.notificationService.errorMessage(res.message);
                hideSpinner();
                return;
            }
            } catch (error) {
            this.notificationService.errorMessage("Ocurrio un error desconocido.")
            hideSpinner();
            return;
            }
            contador++;
        }
        hideSpinner()
        this.notificationService.successMessage("Cargo correctamente")
        this.isFileLoaded = false;
        location.reload()
        } else {
        this.notificationService.infoMessage("No hay nada que enviar")
        }
        
        this.inputFile.value = ""
    }

    setPagination() {
        this.totalPages = Math.ceil(this.filteredCuentas.length / this.pageSize) || 1;
        this.pagesArray = Array(this.totalPages).fill(0).map((x, i) => i + 1);
        if (this.currentPage > this.totalPages) {
            this.currentPage = this.totalPages;
        }
    }

    onSearch() {
        if (!this.searchTerm.trim()) {
            this.filteredCuentas = [...this.cuentasBloqueadas];
        } else {
            const term = this.searchTerm.toLowerCase();
            this.filteredCuentas = this.cuentasBloqueadas.filter(cuenta => 
                (cuenta.N_IDE || '').toLowerCase().includes(term) ||
                (cuenta.CUE || '').toLowerCase().includes(term) ||
                (cuenta.N_ORI || '').toLowerCase().includes(term) ||
                (cuenta.NOMBRE || '').toLowerCase().includes(term)
            );
        }
        this.currentPage = 1;
        this.setPagination();
    }

    async traerCuentasBloqueadas() {
        showSpinner("Cargando cuentas bloqueadas...");
        try {
            const usuario = getCurrentUser();
            const empresa = usuario ? usuario.c_emp : 'JA';
            const resp = await this.cargueService.get_cuentas(empresa || 'JA');
            if (Array.isArray(resp) && resp.length > 0) {
                this.cuentasBloqueadas = resp;
                this.filteredCuentas = [...resp];
            } else {
                this.cuentasBloqueadas = [];
                this.filteredCuentas = [];
            }
            this.setPagination(); // <-- Actualiza la paginación después de cargar datos
        } catch (error) {
            this.notificationService.errorMessage("Ocurrio un error desconocido.")
        }
        hideSpinner();
    }
  async  desbloquearCuenta(cuenta: any) : Promise<void> {
        this.notificationService.warningDialog(
            'Confirmar desbloqueo',
            'Esta cuenta sera liberada ¿esta seguro de realizar esta operacion?',
            'Confirmar',
            async () => {
                const usuario = getCurrentUser();
                const empresa = usuario ? usuario.c_emp : 'JA';
                const usuarioId = usuario ? usuario.usuario_aplicativo : 'SADMIN';
                showSpinner(`Desbloqueando la factura ${cuenta.N_ORI} de la cuenta ${cuenta.CUE}...`);
                const res = await this.cargueService.desbloquear(empresa || 'JA', cuenta,usuarioId);
                hideSpinner()
                if (res.success) {
                    this.notificationService.successMessage(`La Factura ${cuenta.N_ORI} de la Cuenta ${cuenta.CUE} fue desbloqueada correctamente`);
                    setTimeout(() => {
                        location.reload();
                    }, 5000);
                    return;
                }else{
                    this.notificationService.errorMessage(res.message);
                    return;
                }

            }
        );
    }
    // Si modificas cuentasBloqueadas en otro método, llama también a this.setPagination()

    ngOnInit(): void {
        this.traerCuentasBloqueadas();
    }

    onPageSizeChange() {
        this.currentPage = 1;
        this.setPagination();
    }
}
